import { change } from 'redux-form';

import { INFERENTIAL_STATISTICS as FORM } from '../../names';
import { valueTwoSampleProportion } from 'scenes/InferentialStatistics/SettingsForm/defaultValueForProcedures';

// Setters
// First variable
export const setFirstVariable = name =>
  change(FORM, 'twoSampleProportion.firstVariable', name);

export const setSuccessGroupFirst = successGroupFirst =>
  change(FORM, 'twoSampleProportion.successGroupFirst', successGroupFirst);

export const setNumberOfSuccessFirst = numberOfSuccess =>
  change(FORM, 'twoSampleProportion.numberOfSuccessFirst', numberOfSuccess);

export const setNumberOfTrialsFirst = numberOfTrials =>
  change(FORM, 'twoSampleProportion.numberOfTrialsFirst', numberOfTrials);

// Second variable
export const setSecondVariable = name =>
  change(FORM, 'twoSampleProportion.secondVariable', name);

export const setSuccessGroupSecond = successGroupSecond =>
  change(FORM, 'twoSampleProportion.successGroupSecond', successGroupSecond);

export const setNumberOfSuccessSecond = numberOfSuccess =>
  change(FORM, 'twoSampleProportion.numberOfSuccessSecond', numberOfSuccess);

export const setNumberOfTrialsSecond = numberOfTrials =>
  change(FORM, 'twoSampleProportion.numberOfTrialsSecond', numberOfTrials);

export const setDataTwoSampleProportion = ({
  firstVariable,
  secondVariable,
  successGroupFirst,
  successGroupSecond,
  numberOfTrialsFirst,
  numberOfSuccessFirst,
  numberOfSuccessSecond,
  numberOfTrialsSecond
}) => dispatch => {
  if (firstVariable) {
    dispatch([
      setSuccessGroupFirst(successGroupFirst),
      setNumberOfSuccessFirst(numberOfSuccessFirst),
      setNumberOfTrialsFirst(numberOfTrialsFirst)
    ]);
  }
  if (secondVariable) {
    dispatch([
      setSuccessGroupSecond(successGroupSecond),
      setNumberOfSuccessSecond(numberOfSuccessSecond),
      setNumberOfTrialsSecond(numberOfTrialsSecond)
    ]);
  }
};

export const resetDropDownsForFirstVariable = () => dispatch =>
  dispatch([
    setFirstVariable(valueTwoSampleProportion.firstVariable),
    setSuccessGroupFirst(valueTwoSampleProportion.successGroupFirst)
  ]);


export const resetDropDownsForSecondVariable = () => dispatch =>
  dispatch([
    setSecondVariable(valueTwoSampleProportion.secondVariable),
    setSuccessGroupSecond(valueTwoSampleProportion.successGroupSecond)
  ]);
